import { Location, NavigateFunction } from 'react-router'
import { first } from 'rxjs/operators'
import { CHANGE_PASSWORD_ROUTE_PATH, MFA_ROUTE_PATH, routePath } from '../Constants/Constants'
import { requestGetJSON } from '../../NonReact/common/API/REST/RESTAPIClient'
import { APIElements, AUTH_OUTFLOW_URL } from '../../NonReact/constants/ApiConstants'
import { isStringNotEmpty } from '../../NonReact/utils/GlobalFunctions'
import { redirectToServletWithBranding, ServletCmds } from '../../NonReact/constants/ServletCommands'
import { Branding } from '../../React/Common/API/BrandingAPI'
import { resolveAndGetCurrentUserInfo } from '../../NonReact/common/RxJS/UserInfoState'
import { userInfoErrorState$ } from '../../NonReact/common/RxJS/UserInfoErrorState'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { AdminUserResponse, JSONResponse } from '../../NonReact/common/Types/Types'

const outflowRouting = (
    userInfo: Definable<AdminUserResponse>,
    navigate: NavigateFunction,
    location: Location,
    branding: Nullable<Branding>
): void => {
    if (userInfo) {
        if (userInfo?.Advanced?.PromptForTerms) {
            return navigate(routePath(RouteID.TERMS_AND_CONDITIONS), {
                replace: true,
                state: { from: location }
            })
        }

        if (userInfo?.PasswordChgRequired) {
            return navigate(CHANGE_PASSWORD_ROUTE_PATH, {
                replace: true,
                state: { from: location }
            })
        }

        if (userInfo?.EnableMFA) {
            return navigate(MFA_ROUTE_PATH, {
                replace: true,
                state: { from: location }
            })
        }
    }

    requestGetJSON<{ location: string }>(AUTH_OUTFLOW_URL)
        .then((authOutflow: JSONResponse<{ location: string }>): void => {
            if (isStringNotEmpty(authOutflow?.location)) {
                if (authOutflow.location.toLowerCase().includes('cmd_')) {
                    redirectToServletWithBranding(authOutflow.location, branding?.URLMapping ?? APIElements.AKIXI_2019)
                } else {
                    navigate(routePath(authOutflow.location as RouteID), {
                        replace: true,
                        state: { from: location }
                    })
                }
            }
        })
        .catch((): void => {
            // TODO: These will need to be replaced with navigation to the correct paths when there are completed.
            if (userInfo?.InsightsHubHidden) {
                return redirectToServletWithBranding(
                    ServletCmds.RPT_PORTAL,
                    branding?.URLMapping ?? APIElements.AKIXI_2019
                )
            }

            return redirectToServletWithBranding(
                ServletCmds.INSIGHTS_HUB,
                branding?.URLMapping ?? APIElements.AKIXI_2019
            )
        })

    return undefined
}

export const performAuthOutflowRouting = (
    navigate: NavigateFunction,
    location: Location,
    branding?: Nullable<Branding>
): void => {
    resolveAndGetCurrentUserInfo().then((userInfo: Definable<AdminUserResponse>): void =>
        outflowRouting(userInfo, navigate, location, branding)
    )

    userInfoErrorState$.observable.pipe(first()).subscribe((isError: Definable<boolean>): void => {
        if (isError) {
            outflowRouting(undefined, navigate, location, branding)
        }
    })
}

export const createRouteURI = (routeID: RouteID): string => `/${routeID}`
